<template>
    <ManualSection :header="header" :open="open" :state="state" @click="$emit('click')" code="payment">
        <template v-slot:comment v-if="membershipRequest">
            <p v-if="membershipRequest && membershipRequest.paid" class="cmnt text-success">
              Вы оплатили членский взнос, заявка в обработке.
            </p>
        </template>
        <MembershipRequest :memberStatus="memberStatus" :accept="true" :open="true" v-if="membershipRequest && !membershipRequest.paid" mode="subsection" />
    </ManualSection>
</template>

<script>
import MembershipRequest from '@/components/MembershipRequest.vue'
import ManualSection from '@/components/ManualSection.vue'

export default {
    props: {
        header: String,
        open: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        MembershipRequest,
        ManualSection,
    },
    computed: {
        memberStatus() {
            return this.$store.getters.getUserData.memberInfo?.status      // статус членства
        },
        membershipRequest() {
          return this.$store.getters.getUserData.memberInfo?.membershipRequest
        },
        state() {
            if (!this.membershipRequest) return 'warning';
            if (!this.membershipRequest.paid) return 'warning';
            return 'success'
        }
    }
}
</script>
